import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MessagingDataComponent } from './messaging-data.component';

const routes: Routes = [
  {
    path: "",
    component: MessagingDataComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MessagingDataRoutingModule { }
